import { React, useState } from 'react';
import { showToast } from '../../../Utils';
import { apiCall } from '../../../api/Interactor';
import { NavLink, useNavigate } from 'react-router-dom';

export default function Registration(props) {

    const navigate = useNavigate();

    let [name, setName] = useState("");
    let [phoneNumber, setPhoneNumber] = useState("");
    let [email, setEmail] = useState("");
    let [password, setPassword] = useState("");
    let [confirmPassword, setConfirmPassword] = useState("");

    const callPostRegistration = () => {
        apiCall(
            "POST", process.env.REACT_APP_USER_REGISTRATION,
            {
                "user_admin": {
                    "email": email,
                    "password": password,
                    "password_confirmation": confirmPassword,
                    "name": name,
                    "phone_number": phoneNumber
                }
              }
              ,
            (response) => {
                console.log(response)
                showToast("Success", "Success", response.data.meta.message)
                setTimeout(() => {
                    navigate('/login');
                }, 2000)
            },
            (message) => {
                showToast("Error", "Failed", message)
            }
        )
    }


    return (
        <main className="flex-1 flex-col px-10 py-12">
            <div className="flex flex-col text-gray-600 space-y-5">
                <div className="text-center pb-4">
                    <img src="/logo_fityuk.webp" width={240} className="mx-auto" />
                    <div className="mt-8">
                        <h3 className="text-gray-800 text-xl font-semibold">Registration new account</h3>
                    </div>
                </div>
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        callPostRegistration();
                    }}
                    className="space-y-5"
                >
                    <div>
                        <label className="font-medium">
                            Name
                        </label>
                        <input
                            onChange={(e) => { setName(e.target.value) }}
                            value={name}
                            type="name"
                            required
                            className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg"
                        />
                    </div>
                    <div>
                        <label className="font-medium">
                            Phone Number
                        </label>
                        <input
                            onChange={(e) => { setPhoneNumber(e.target.value) }}
                            value={phoneNumber}
                            type="tel"
                            required
                            className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg"
                        />
                    </div>
                    <div>
                        <label className="font-medium">
                            Email
                        </label>
                        <input
                            onChange={(e) => { setEmail(e.target.value) }}
                            value={email}
                            type="email"
                            required
                            className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg"
                        />
                    </div>
                    <div>
                        <label className="font-medium">
                            Password
                        </label>
                        <input
                            onChange={(e) => { setPassword(e.target.value) }}
                            value={password}
                            type="password"
                            required
                            className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg"
                        />
                    </div>
                    <div>
                        <label className="font-medium">
                            Confirm Password
                        </label>
                        <input
                            onChange={(e) => { setConfirmPassword(e.target.value) }}
                            value={confirmPassword}
                            type="password"
                            required
                            className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg"
                        />
                    </div>
                    <div></div>
                    <button
                        className="w-full px-4 py-2 text-white font-medium bg-indigo-600 hover:bg-indigo-500 active:bg-indigo-600 rounded-lg duration-150"
                    >
                        Registration
                    </button>
                </form>
                <div></div>
                <p className="text-center">Have an account? <NavLink
                    to="/login"
                    className="font-medium text-indigo-600 hover:text-indigo-500">
                    Login
                </NavLink></p>
            </div>
        </main>
    );
}